import React from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { withTheme } from "styled-components";

function StyledSelect({
  options,
  theme: styledTheme,
  isLoading,
  loadOptionsAsync,
  refTo,
  value,
  isMulti,
  error,
  isClearable,
  onChange,
  defaultValue,
  placeholder = "Selecione um",
  noOptionsMessage = () => "Nenhuma opção",
  name,
  inputId,
  ...props
}) {
  // Só aplica filtro local se não houver filterOption customizado e se as opções tiverem campo search
  if (
    !props.filterOption &&
    options &&
    options.find((option) => option.search)
  ) {
    props.filterOption = (option, rawInput) => {
      return option.data.search.toLowerCase().includes(rawInput.toLowerCase());
    };
  }

  if (refTo) {
    props.ref = (input) => refTo(input);
  }

  if (loadOptionsAsync) {
    return (
      <AsyncSelect
        cacheOptions
        loadOptions={loadOptionsAsync}
        defaultOptions={options}
        placeholder={placeholder}
        noOptionsMessage={noOptionsMessage}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
        isMulti={isMulti}
        inputId={inputId || name}
        name={name}
        loadingMessage={() => "Carregando"}
        isClearable={isClearable}
        styles={{
          container: (e) => ({
            ...e,
            width: "100%",
          }),
          control(e) {
            return error
              ? {
                  ...e,
                  borderColor: styledTheme.colors.error,
                }
              : e;
          },
          menu(e) {
            return {
              ...e,
              zIndex: 60,
              // position: 'relative',
            };
          },
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary: styledTheme.colors.primary,
            primary25: styledTheme.colors.primary03,
            primary75: styledTheme.colors.primary07,
            primary50: styledTheme.colors.primary05,
          },
        })}
        {...props}
      />
    );
  } else {
    // Se houver onMenuScrollToBottom, adiciona event listener no menuList
    const menuListProps = props.onMenuScrollToBottom
      ? {
          onScroll: (e) => {
            const { target } = e;
            // Quando chega perto do final (dentro de 50px), dispara o callback
            if (
              target.scrollHeight - target.scrollTop <=
              target.clientHeight + 50
            ) {
              props.onMenuScrollToBottom();
            }
          },
        }
      : undefined;

    return (
      <Select
        placeholder={placeholder}
        options={options}
        noOptionsMessage={noOptionsMessage}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
        isMulti={isMulti}
        inputId={inputId || name}
        name={name}
        isClearable={isClearable}
        isLoading={isLoading}
        menuListProps={menuListProps}
        styles={{
          container: (e) => ({
            ...e,
            width: "100%",
          }),
          control(e) {
            return error
              ? {
                  ...e,
                  borderColor: styledTheme.colors.error,
                }
              : e;
          },
          menu(e) {
            return {
              ...e,
              zIndex: 60,
              // position: 'relative',
            };
          },
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary: styledTheme.colors.primary,
            primary25: styledTheme.colors.primary03,
            primary75: styledTheme.colors.primary07,
            primary50: styledTheme.colors.primary05,
          },
        })}
        {...props}
      />
    );
  }
}

export default withTheme(StyledSelect);
